export const replaceUrlDomain = url => {
  if (!url || typeof url !== 'string' || !url.includes('http')) {
    return url;
  }
  const isIcslEnv = window.location.hostname.includes("icsl");
  const backHostName = window.location.hostname.replace(`${isIcslEnv ? 'open-icsl' : 'open'}.`, '');
  let needReplaceDomain = false;
  const hostnameArr = backHostName.split('.');
  // 域名后缀
  const currentDomain = `.${hostnameArr[hostnameArr.length - 1]}`;
  const currentUrlWithDomain = backHostName.replace(currentDomain, '');
  if (url.includes(currentUrlWithDomain)) {
    needReplaceDomain = true;
  }
  if (!needReplaceDomain) {
    return url;
  }

  // 替换域名后缀为当前hostname的后缀
  return url.replace(/(http[s]?:\/\/)([\w\.\-]*)/, ($0, $1, $2) => {
    const urlArr = $2.split('.');
    const urlDomain = `.${urlArr[urlArr.length - 1]}`;
    const urlWithDomain = $2.replace(urlDomain, '');
    return $1 + urlWithDomain + currentDomain;
  });
};
